import gvpMemberLogo from '../../img/rnd/GVP-Logo_Mitglied_quer_weiss_RGB_2 1.png';
import type { LandingLocale, LandingNavItem } from '../../shared/content/landingContent.js';

export interface NavigationAboutItem extends LandingNavItem {
  text: string;
  external?: boolean;
  logo?: string;
}

const gvpItem = (locale: LandingLocale): NavigationAboutItem => ({
  label: locale === 'tr' ? 'GVP üyesi' : locale === 'en' ? 'GVP member' : 'Mitglied im GVP',
  text:
    locale === 'tr'
      ? 'Almanya Personel Hizmet Sağlayıcıları Birliği'
      : locale === 'en'
        ? 'German Association of Staffing Services'
        : 'Gesamtverband der Personaldienstleister',
  href: 'https://personaldienstleister.de/',
  external: true,
  logo: gvpMemberLogo,
});

export const navigationAboutItems = (locale: LandingLocale): NavigationAboutItem[] => {
  if (locale === 'tr') {
    return [
      { label: 'Misyon', text: 'Vizyon, yaklaşım ve değerler', href: '/ueber-vivaporta' },
      { label: 'Ekip', text: 'Kurucular ve kişisel destek', href: '/team' },
      { label: 'İletişim', text: 'Doğrudan danışmanlık ve sorular', href: '/kontakt' },
      gvpItem(locale),
      { label: 'Künye', text: 'Şirket ve yasal bilgiler', href: '/impressum' },
    ];
  }

  if (locale === 'en') {
    return [
      { label: 'Mission', text: 'Vision, approach and values', href: '/ueber-vivaporta' },
      { label: 'Team', text: 'Founders and personal support', href: '/team' },
      { label: 'Contact', text: 'Direct advice and questions', href: '/kontakt' },
      gvpItem(locale),
      { label: 'Legal notice', text: 'Company and legal information', href: '/impressum' },
    ];
  }

  return [
    { label: 'Mission', text: 'Vision, Haltung und Werte', href: '/ueber-vivaporta' },
    { label: 'Unser Team', text: 'Gründerteam und persönliche Betreuung', href: '/team' },
    { label: 'Kontakt', text: 'Direkte Beratung und Rückfragen', href: '/kontakt' },
    gvpItem(locale),
    { label: 'Impressum', text: 'Unternehmens- und Pflichtangaben', href: '/impressum' },
  ];
};
